import { Injectable, inject } from '@angular/core';
import { settingsSelectors, State, UserType } from '@wam/shared';
import { select, Store } from '@ngrx/store';

import * as messagesAndNotificationsActions from './state/messages-and-notifications.actions';
import { isNil } from 'lodash-es';
import { filter, map, skipWhile, take, tap } from 'rxjs/operators';
import { combineLatest, Observable } from 'rxjs';
import { WebSocketService } from '@app/shared/web-socket.service';
import { isReportsApp } from '@app/reports-app/reports-app.util';

@Injectable({
  providedIn: 'root',
})
export class MessagesAndNotificationsInitializerService {
  private store = inject<Store<State>>(Store);
  private websocketService = inject(WebSocketService);

  initialize(): Observable<boolean> {
    const getSettings$ = this.store.pipe(select(settingsSelectors.getSettings), skipWhile(isNil));
    const userType$ = this.store.pipe(select(settingsSelectors.getUserType));

    return combineLatest([getSettings$, userType$]).pipe(
      // The standalone reports app has no notifications UI, and its users (e.g. `ext-parent`) may
      // not even have a `feed` for the notifications request to target - skip it entirely there.
      map(([, userType]) => userType === UserType.TEACHER && !isReportsApp()),
      tap((shouldLoadNotifications) => {
        if (shouldLoadNotifications) {
          this.store.dispatch(messagesAndNotificationsActions.loadNotifications());

          this.subscribeToNotificationReceived();
        }
      }),
      take(1),
    );
  }

  private subscribeToNotificationReceived(): void {
    this.websocketService.connect$
      .pipe(filter(({ message }) => message === 'NOTIFICATION_RECEIVED'))
      .subscribe(() => {
        this.store.dispatch(messagesAndNotificationsActions.loadNotifications());
      });
  }
}
